import React from 'react'
import { Text } from '../ui'
import type { Ligacao } from '../../types/helpdeskLigacao'
import type { LigacaoRelatorioRow } from '../../types/comercialContatosPortal'

export type HistoricoContatosTableRow = Ligacao | LigacaoRelatorioRow

export function formatarDataHoraContato(data: string, horario: string): string {
  try {
    const dataObj = new Date(`${data}T${horario}`)
    const dia = String(dataObj.getDate()).padStart(2, '0')
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0')
    const ano = dataObj.getFullYear()
    return `${dia}/${mes}/${ano} ${horario}`
  } catch {
    return `${data} ${horario}`
  }
}

export function isRelatorioRow(row: HistoricoContatosTableRow): row is LigacaoRelatorioRow {
  return 'corretora_nome' in row && typeof (row as LigacaoRelatorioRow).corretora_nome === 'string'
}

export function feedbackLabel(feedback: Ligacao['feedback_geral']): string {
  if (!feedback) return '-'
  const labels: Record<NonNullable<Ligacao['feedback_geral']>, string> = {
    positivo: 'Positivo',
    neutro: 'Neutro',
    negativo: 'Negativo',
  }
  return labels[feedback]
}

export function resolveContatoAtendido(
  row: HistoricoContatosTableRow
): { nome: string; cargo?: string } | null {
  if (isRelatorioRow(row) && row.contato_nome) {
    return { nome: row.contato_nome, cargo: row.contato_cargo }
  }
  const label = row.attended_contact_label?.trim()
  if (label) return { nome: label }
  return null
}

export function MeioContatoBadge({ tipo }: { tipo: Ligacao['tipo_contato'] }) {
  if (!tipo) {
    return (
      <Text size="sm" color="muted">
        -
      </Text>
    )
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
        tipo === 'telefone'
          ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300'
          : tipo === 'email'
            ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300'
            : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
      }`}
    >
      {tipo === 'telefone' ? 'Telefone' : tipo === 'email' ? 'E-Mail' : 'WhatsApp'}
    </span>
  )
}

export function TipoContatoBadge({ tipo }: { tipo: Ligacao['tipo'] }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
        tipo === 'ativo'
          ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'
          : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
      }`}
    >
      {tipo === 'ativo' ? 'Ativo' : 'Receptivo'}
    </span>
  )
}

export function TeveContatoBadge({
  teveContato,
  plain = false,
}: {
  teveContato: boolean
  /** Só texto colorido, sem pill de fundo */
  plain?: boolean
}) {
  const label = teveContato ? 'Sim' : 'Não'
  const tone = teveContato
    ? 'text-green-800 dark:text-green-300'
    : 'text-red-800 dark:text-red-300'

  if (plain) {
    return <span className={`text-sm font-medium ${tone}`}>{label}</span>
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
        teveContato
          ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
          : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
      }`}
    >
      {label}
    </span>
  )
}
